import React from 'react'
import Reports from '../components/Reports';
import SideBar from '../components/SideBar';
import Header from '../components/Header';

const ReportsPage = () => {
  return (
    <>
        <SideBar />
        <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
            <Header title="Reports" />
            <Reports />
        </main>
    </>
  )
}

export default ReportsPage
